import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { DoneTotal, EngineeringState } from 'features/EngineeringNetStatus/types';

const initialState: EngineeringState = {
  loading: false,
  networkDone: undefined,
  structureDone: undefined,
  unclosedComments: undefined,
};

const reset = () => initialState;

const structureDone: CaseReducer<
  EngineeringState,
  PayloadAction<{ done: number; total: number }>
> = (state, action) => {
  state.structureDone = action.payload;
};

const networkDone: CaseReducer<EngineeringState, PayloadAction<{ done: number; total: number }>> = (
  state,
  action,
) => {
  state.networkDone = action.payload;
};

const unclosedCommentsDone: CaseReducer<
  EngineeringState,
  PayloadAction<{ done: number; total: number }>
> = (state, action) => {
  state.unclosedComments = action.payload;
};

export const engineeringInfoSlice = createSlice({
  name: 'CARDS/engineering',
  initialState,
  reducers: {
    loading: loading as IReducer<EngineeringState, boolean>,
    structureDone,
    networkDone,
    unclosedCommentsDone,
    reset,
  },
});

const {
  reset: setEngineeringReset,
  networkDone: setNetworkDone,
  structureDone: setStructureDone,
  unclosedCommentsDone: setUnclosedCommentsDone,
} = engineeringInfoSlice.actions;

export const getEngineeringDoneInfo =
  (structure: number, networkId: number): AppThunk =>
  dispatch => {
    get<DoneTotal>(
      `/api/standards/structures/${structure}/engineering_subnets_total/${networkId}/`,
    ).then(({ data }) => {
      dispatch(setNetworkDone(data));
    });

    get<DoneTotal>(`/api/standards/structures/${structure}/engineering_networks_total/`).then(
      ({ data }) => {
        dispatch(setStructureDone(data));
      },
    );

    get<DoneTotal>(`/api/standards/structures/${structure}/en-issues-total/`).then(({ data }) => {
      dispatch(setUnclosedCommentsDone(data));
    });
  };

export { setEngineeringReset };
